
export const EVENT_GROUP_STYLES = {
  1: 'row-accessories-yellow',
  3: 'row-accessories-red_ligt',
  4: 'row-accessories-orange',
  default: 'row-accessories-green'
};

export const EVENT_TYPE_STYLES = {
  1: 'row-accessories-green',
  2: 'row-accessories-yellow',
  3: 'row-accessories-green',
  4: 'row-accessories-red_ligt',
  5: 'row-accessories-orange',
  default: 'row-accessories-green'
};